export const typeReservationConstants = {
    FETCHING_TYPE_RESERVATION_SUCCESS:'FETCHING_TYPE_RESERVATION_SUCCESS',
}